import r from "react";
import d from "@appchoose/cn";
const c = ({
  position: e,
  children: a
}) => /* @__PURE__ */ r.createElement(
  "div",
  {
    className: d("absolute inset-y-0 flex items-center", {
      "left-0 pl-2 [&:has(~_:disabled)]:text-gray-300": e === "start",
      "right-0 pr-2 peer-disabled:text-gray-300": e === "end"
    })
  },
  a
), n = r.forwardRef(
  ({ className: e, type: a, startAdornment: t, endAdornment: l, ...i }, o) => /* @__PURE__ */ r.createElement("div", { className: "relative w-full text-gray-500 transition-colors duration-300 focus-within:text-gray-900" }, t ?? null, /* @__PURE__ */ r.createElement(
    "input",
    {
      type: a,
      className: d(
        'form-input block w-full rounded border border-gray-500 p-2 text-sm leading-5.5 text-gray-900 placeholder-gray-500 outline-none transition duration-300 hover:border-gray-700 focus:border-gray-700 focus:ring-gray-700 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-500 disabled:placeholder-gray-300 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:ring-red-600',
        {
          "pl-8": !!t,
          "peer pr-8": !!l
        },
        e
      ),
      ref: o,
      ...i
    }
  ), l ?? null)
);
n.displayName = "Input";
export {
  c as InputAdornment,
  n as default
};
